import React, { useMemo } from 'react';
import { getFirstName } from 'utils';
import { getCurrentUser, isUserLoading, isRegisteredUser, getUserPaymentDetails, getZppAttendances } from 'redux/query';
import { useDispatch, useSelector } from 'react-redux';
import { Spinner } from 'Common';
import { logoutUser } from 'redux/actions';

export const ProfileNavigationHeader = () => {
  const dispatch = useDispatch();

  const user = useSelector(getCurrentUser);
  const isLoading = useSelector(isUserLoading);
  const registeredUser = useSelector(isRegisteredUser);
  const { product } = useSelector(getUserPaymentDetails);
  const userZppAttendances = useSelector(getZppAttendances);

  const subscriptionTitle = useMemo(() => {
    const subscriptionPlans = (user?.subscriptions || [])
      .filter((sub) => !!sub?.subscriptionPlan?.title)
      .map((sub) => sub.subscriptionPlan);
    const productName = subscriptionPlans?.find((plan) => !plan.zppCertified)?.title;

    switch (true) {
      case !!productName && userZppAttendances.length > 1:
        return `${productName} &\n Präventionskurse`;
      case !!productName && !!userZppAttendances.length:
        return `${productName} &\n Präventionskurs`;
      case !!productName:
        return productName;
      case userZppAttendances.length > 1:
        return 'Präventionskurse';
      case !!userZppAttendances.length:
        return 'Präventionskurs';
      case !!product:
        return product;
      default:
        return 'Kein Abo';
    }
  }, [user, userZppAttendances, product]);

  if (!registeredUser) {
    return dispatch(logoutUser());
  }

  if (isLoading || !user) {
    return <Spinner />;
  }

  return (
    <div className="profile-navigation-header">
      <div className="profile-navigation-header__user-name" data-cy-name="greeting-header">
        Hallo {getFirstName(user?.firstName)}!
      </div>
      <span
        data-cy-name="subscription-status"
        className={
          'profile-navigation-header__subscription-status profile-navigation-header__subscription-status' +
          (subscriptionTitle ? '--active' : '--inactive')
        }
      >
        {subscriptionTitle ? subscriptionTitle : 'kein abo aktiv'}
      </span>
    </div>
  );
};
